import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAppContext } from "contexts";

interface ProtectedRoutesProps {
  allowedRoles?: number[];
}

export default function ProtectedRoutes({
  allowedRoles = [2],
}: ProtectedRoutesProps) {
  const { userRole } = useAppContext();
  const store = localStorage.getItem("user");

  let effectiveRole = userRole;
  if (store) {
    const user = JSON.parse(store);

    if (user && user.role) {
      effectiveRole = user.role;
    }
  }
  console.log("userRole", effectiveRole);
  console.log("ProtectedRoutes userRole");
  if (allowedRoles.includes(Number(effectiveRole))) {
    return <Outlet />;
  } else {
    return <Navigate to="/admin/profile" />;
  }
}
